import institutionAPI from 'services/institutionAPI'
import { RoleFilters } from 'Attendances/types'

type Params = {
  filters: RoleFilters
}

export default async function readRolesOnCustomForm({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/citizen-portal/service/roles',
    data: filters,
  })

  return response
}
